<div class="deal-loan-status-wrapper">
  <div>
    <div class="deal-details-row">
      <h2 class="mb-0">Status</h2>
    </div>

    <div class="deal-loan-status-row">
      <h4 class="mb-0">Paid Down Percent</h4>
      <div class="deal-loan-status-green">
        {{ deal.funded_loan_status.paidDown != null ? deal.funded_loan_status.paidDown : '' }}%
      </div>
    </div>

    <div class="deal-loan-status-row">
      <h4 class="mb-0">Missed Payments</h4>
      <div [ngClass]="{'deal-loan-status-red' : deal.funded_loan_status.missedPayments > 0}">
        {{ deal.funded_loan_status.missedPayments != null ? deal.funded_loan_status.missedPayments : '' }}
      </div>
    </div>

    <div class="deal-loan-status-row">
      <h4 class="mb-0">Renewal Eligibility Date</h4>
      <div>{{ deal.funded_loan_status.expectedRenewalEligibilityDate || '' | date }}</div>
    </div>

    <div class="deal-loan-status-row">
      <h4 class="mb-0">Beginning Balance</h4>
      <div>
        {{ deal.funded_loan_status.beginningBalance != null ? deal.funded_loan_status.beginningBalance : '' |
        currency:'USD':'symbol':'1.0-2' }}
      </div>
    </div>

    <div class="deal-loan-status-row">
      <h4 class="mb-0">Remaining Balance</h4>
      <div>
        {{ deal.funded_loan_status.remainingBalance != null ? deal.funded_loan_status.remainingBalance : '' |
        currency:'USD':'symbol':'1.0-2' }}
      </div>
    </div>
  </div>
</div>
